import React from 'react';
import { ChevronRightIcon, HistoryIcon } from 'lucide-react';
import { providers } from '../../data/providers';
import type { HistoryEntry } from '../../types/aus';
import { ProviderMark } from './ProviderMark';
interface SubmissionHistoryProps {
  entries: HistoryEntry[];
  onSelect: (entry: HistoryEntry) => void;
}
export function SubmissionHistory({
  entries,
  onSelect
}: SubmissionHistoryProps) {
  if (entries.length === 0) {
    return null;
  }
  return <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-292" data-mp="2dffvd5pi3zoc">
      <header className="flex items-center justify-between gap-4 border-b border-slate-100 px-5 py-3.5" data-id="element-293" data-mp="28glc62nmg93p">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-900" data-id="element-294" data-mp="23lfj8jvsxu64">
          <HistoryIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-295" data-mp="1ymmebfukzbhk" />
          Submission History
        </h3>
        <span className="text-xs text-slate-400" data-id="element-296" data-mp="2rdcw8eazms8t">{entries.length} runs</span>
      </header>

      <ul className="divide-y divide-slate-100" data-id="element-297" data-mp="2rbjoswsjw3zr">
        {entries.map(entry => {
        const config = providers[entry.provider];
        return <li key={entry.id} data-id="element-298" data-mp="3m6z0pnkeg708">
              <button type="button" onClick={() => onSelect(entry)} className="flex w-full items-center gap-4 px-5 py-3.5 text-left transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-slate-900" data-id="element-299" data-mp="3ma3ad0gmvuya">
                <ProviderMark provider={entry.provider} size="sm" data-id="element-300" data-mp="32kstvk92d5z4" />
                <div className="min-w-0 flex-1" data-id="element-301" data-mp="32hy9tttypn68">
                  <p className="flex items-center gap-2 truncate text-sm font-medium text-slate-900" data-id="element-302" data-mp="2oljqxm9vc8d3">
                    {config.name} {config.shortLabel === 'LPA' ? 'LPA' : 'DU'}
                    {entry.dual && <span className="rounded-md bg-brand-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-brand-700" data-id="element-303" data-mp="mtoj5hqqgo05">
                        Dual run
                      </span>}
                  </p>
                  <p className="text-xs text-slate-500 sm:hidden" data-id="element-304" data-mp="lc9ckaqacc9o">{entry.submittedAt}</p>
                </div>
                <span className="hidden w-40 text-sm text-slate-600 sm:block" data-id="element-305" data-mp="gcd7e85uqesj">{entry.result}</span>
                <span className="hidden w-48 text-sm text-slate-500 md:block" data-id="element-306" data-mp="bebp3pg92ji4">
                  {entry.submittedAt}
                </span>
                <span className="hidden w-40 text-sm text-slate-500 lg:block" data-id="element-307" data-mp="1910zaml3w2f2">
                  {entry.submittedBy}
                </span>
                <ChevronRightIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-slate-300" data-id="element-308" data-mp="zbr5916pc9ob" />
              </button>
            </li>;
      })}
      </ul>
    </section>;
}